export const ACCESS_TOKEN_NAME = 'access_token'
export const AUTHORITIES_NAME = 'authorities'
export const USER_NAME = 'userName'
export const USER_ID = 'userId'
export const EXP_TOKEN = 'exp_token'
export const FILE_MERGE_MAX_SIZE = 1073741824 /* 2048MB */
export const LOCATION_CODE_NAME = 'location_code'
export const FULL_NAME = 'full_name'
export const USER_POSITION = 'user_position'
export const FILE_MAX_SIZE = 2147483648 /* 2048MB */
export const IS_CHECK_MAX_SIZE_UPLOAD = true

export const Roles = {
  ADMIN: 'ROLE_ADMIN',
  PROVINCE: 'ROLE_MANAGER',
  DISTRICT: 'ROLE_USER',
  WARD: 'ROLE_WARD'
};

export const Authorities = {
  Central: 1,           /* Cấp trung ướng */
  Provincial: 2,        /* Cấp tỉnh */
  District: 3,          /* Cấp huyện */
  Wards: 4,             /* Cấp xã */
}

export const sourceType = {
  TRUNG_UONG: 0,
  BIEN_TAP: 1,
  CHUYEN_DOI_VAN_BAN: 2,
  GHEP_TEP: 3,
  GHI_AM_TEP_TIN: 4
}

export const AudioHistoryType = {
  NHAN_BAN_TIN: 0, /* Nhận được bản tin */
  DA_PHAT: 1, /* Đã phát bản tin */
  DA_HUY: 3, /* Đã hủy bản tin */
  DANG_PHAT: 2, /* Đang phát bản tin */
  PHAT_LOI: 4 /* Phát lỗi bản tin */
}

export const ScreenHistoryType = {
  NHAN_BAN_TIN: 0, /* Nhận được bản tin */
  DA_PHAT: 1, /* Đã phát bản tin */
  DA_HUY: 3, /* Đã hủy bản tin */
  DANG_PHAT: 2, /* Đang phát bản tin */
  PHAT_LOI: 4 /* Phát lỗi bản tin */
}

export const ActionEditor = {
  LAYOUT_SETTING: 0,
  ADD_LAYER: 1,
  EDITOR_LAYER: 2,
  PREVIEW: 3,
}

export const TypeChooseLayer = {
  TEXT: 0,
  IMAGE: 1,
  VIDEO: 2,
  PLAY_LIST: 3,
  YOUTUBE: 4,
  RSS: 5,
  DOCUMENT: 6,
  AREA_TEXT: 7,
  AREA_LEFT: 8,
  AREA_RIGHT: 9,
  FULL_SCREEN: 10,
  STREAM_VTV: 11,
  WIDGET: 12
}

export const TypePlayList = {
  TEXT_RUN: -1,
  TEXT_NORMAL: 0,
  IMAGE: 1,
  VIDEO: 2,
  DOCUMENT: 4
}

export const TypeActionFileList = {
  DELETE_LIST: 1,
  ACCEPT_LIST: 2,
  REJECT_LIST: 3,
  CHANGE_VOLUME_LIST: 4,
  CONFIG_ON_OFF_LIST: 5,
  RESTART_LIST: 6,
  UPDATE_APP_LIST: 7
}

export const FontGoogle = [
  {id: 1, name: "Arial", value: "Arial", _style: "font-family: Arial"},
  {id: 2, name: "Lobster", value: "'Lobster', cursive;", _style: "font-family: 'Lobster', cursive;"},
  {
    id: 3,
    name: "Dancing Script",
    value: "'Dancing Script', cursive;",
    _style: "font-family: 'Dancing Script', cursive;"
  },
  {id: 4, name: "Lobster Two", value: "'Lobster Two', cursive;", _style: "font-family: 'Lobster Two', cursive;"},
  {id: 5, name: "Parisienne", value: "'Parisienne', cursive;", _style: "font-family: 'Parisienne', cursive;"},
  {id: 6, name: "Tangerine", value: "'Tangerine', cursive;", _style: "font-family: 'Tangerine', cursive;"},
  {id: 7, name: "Lakki+Reddy", value: "'Lakki Reddy', cursive;", _style: "font-family: 'Lakki Reddy', cursive;"},
]

export const CLIENT_ID = '33db9aecf06424b2d03646094cc36fa675e1d2ad43da60fc9629ed1a8ddd7750';

export const CHANGE_VOLUME = "CHANGE_VOLUME"
export const RESTART_DEVICE = "RESTART_DEVICE"

export const HistoryTypeList = [
  {
    key: "null",
    value: "Tất cả trạng thái"
  },
  {
    key: "0",
    value: "Đang phát"
  },
  {
    key: "1",
    value: "Đã phát"
  },
  {
    key: "2",
    value: "Phát lỗi"
  }
]
